module.exports = __webpack_public_path__ + "static/media/vn.a0081482.svg";